export const state = {
  pettycashes: [],
  pettycash:[]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/state.js